import qs from 'qs'
import { CategoryList } from '../../../../types/ExpenseManagement/Category/categoryListTypes'
import {
  CountriesListResponse,
  CreditCardListResponse,
  EmpDepartmentListResponse,
  GetExpenseDetails,
  GetExpensePaymentList,
  GetpayAllAtOnceProps,
  PaymentList,
  ReimbursementExpenseListResponse,
  SavePaymentFormParams,
  getReimbursementExpenseListProps,
} from '../../../../types/ExpenseManagement/PaymentList/PaymentListTypes'
import { ApiParams } from '../../../../types/commonTypes'
import {
  getAuthenticatedRequestConfig,
  useAxios,
} from '../../../../utils/apiUtils'
import {
  AllowedHttpMethods,
  categoryListApiConfig,
  expenseFormApiConfig,
  paymentListApiConfig,
} from '../../apiList'

const getDepartmentsDetails = async (): Promise<
  EmpDepartmentListResponse[]
> => {
  const requestConfig = getAuthenticatedRequestConfig({
    url: paymentListApiConfig.getDepartments,
    method: AllowedHttpMethods.get,
  })
  const response = await useAxios(requestConfig)
  return response.data
}
const getCountryDetails = async (): Promise<CountriesListResponse[]> => {
  const requestConfig = getAuthenticatedRequestConfig({
    url: paymentListApiConfig.getCountries,
    method: AllowedHttpMethods.get,
  })
  const response = await useAxios(requestConfig)
  return response.data
}

const getExpenseCategories = async (): Promise<CategoryList[]> => {
  const requestConfig = getAuthenticatedRequestConfig({
    url: categoryListApiConfig.getCategoryList,
    method: AllowedHttpMethods.get,
  })

  const response = await useAxios(requestConfig)
  return response.data
}

const getPaymentList = async (): Promise<PaymentList[]> => {
  const requestConfig = getAuthenticatedRequestConfig({
    url: expenseFormApiConfig.getPaymentList,
    method: AllowedHttpMethods.get,
  })

  const response = await useAxios(requestConfig)
  return response.data
}
const getCreditCardsList = async (): Promise<CreditCardListResponse[]> => {
  const requestConfig = getAuthenticatedRequestConfig({
    url: expenseFormApiConfig.getCardsList,
    method: AllowedHttpMethods.get,
  })

  const response = await useAxios(requestConfig)
  return response.data
}

const getExpenseDetailsById = async (
  formId: number,
): Promise<GetExpenseDetails> => {
  const requestConfig = getAuthenticatedRequestConfig({
    url: paymentListApiConfig.getExpenseDetails,
    method: AllowedHttpMethods.get,
    params: {
      formId,
    },
  })

  const response = await useAxios(requestConfig)
  return response.data
}

const getpayAllAtOnce = async (
  prepareObject: GetpayAllAtOnceProps,
): Promise<number[] | undefined> => {
  const requestConfig = getAuthenticatedRequestConfig({
    url: paymentListApiConfig.payAllAtOnce,
    method: AllowedHttpMethods.post,
    params: {
      formIds: prepareObject.formsIds,
    },
    paramsSerializer: (params: ApiParams) =>
      qs.stringify(params, { arrayFormat: 'repeat' }),
    data: {
      chequeDate: prepareObject.chequeDate,
      chequeNumber: prepareObject.chequeNumber,
      modeOfPayment: prepareObject.modeOfPayment,
      paidAmount: prepareObject.paidAmount,
      rtgsDate: prepareObject.rtgsDate,
    },
  })

  const response = await useAxios(requestConfig)
  return response.data
}
const getExpensePaymentList = async (
  expenseId: number,
): Promise<GetExpensePaymentList[]> => {
  const requestConfig = getAuthenticatedRequestConfig({
    url: paymentListApiConfig.getExpensePaymentList,
    method: AllowedHttpMethods.get,
    params: {
      expenseId,
    },
  })

  const response = await useAxios(requestConfig)
  return response.data
}
const savePaymentForm = async (
  savePaymentForm: SavePaymentFormParams,
): Promise<number> => {
  const requestConfig = getAuthenticatedRequestConfig({
    url: paymentListApiConfig.savePaymentForm,
    method: AllowedHttpMethods.post,
    data: savePaymentForm,
  })
  const response = await useAxios(requestConfig)
  return response.data
}

const getReimbursementExpenseList = async (
  props: getReimbursementExpenseListProps,
): Promise<ReimbursementExpenseListResponse> => {
  const requestConfig = getAuthenticatedRequestConfig({
    url: paymentListApiConfig.getReimbursementExpenseList,
    method: AllowedHttpMethods.get,
    params: {
      categoryId: props.categoryId,
      country: props.country,
      creditCardId: props.creditCardId,
      dateSelection: props.dateSelection,
      departmentId: props.departmentId,
      endIndex: props.endIndex,
      from: props.from,
      multipleSearch: props.multipleSearch,
      paymentMode: props.paymentMode,
      paymentStatus: props.paymentStatus,
      startIndex: props.startIndex,
      to: props.to,
    },
  })

  const response = await useAxios(requestConfig)
  return response.data
}

const paymentListApi = {
  getDepartmentsDetails,
  getCountryDetails,
  getExpenseCategories,
  getPaymentList,
  getCreditCardsList,
  getReimbursementExpenseList,
  getExpenseDetailsById,
  savePaymentForm,
  getExpensePaymentList,
  getpayAllAtOnce,
}

export default paymentListApi
